// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"p4-z","displaySixCardTiles":"q4-z"};